import { render, staticRenderFns } from "./TheConfirmedIcon.vue?vue&type=template&id=031ccf9c&"
import script from "./TheConfirmedIcon.vue?vue&type=script&lang=js&"
export * from "./TheConfirmedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports